export default "__VITE_ASSET__jP_TlVZh__"